var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkChartStyleBaseline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.285645 5.28571H12.8571",
    stroke: "#828282",
    strokeDasharray: "1 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28564 4.14286L3.4285 1.85714L3.99993 3L5.14279 0.714287L6.85707 4.14286",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14272 6.42857L0.571289 7.57143",
    stroke: "#828282",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.42857L9.14286 8.71429L10.2857 6.42857H8ZM11.4286 4.14286L12 3L11.4286 4.14286Z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkChartStyleBaseline);
export default __webpack_public_path__ + "static/media/dark-chart-style-baseline.4adbe5181c8712f8b16056750fab2f0d.svg";
export { ForwardRef as ReactComponent };